import Joi from 'joi';

/**
 * Schema for new filebox record validation.
 */
export const createFileboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
